import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { CONSTANTS, NOTIFY, PLATFORM, STATUS_ACTIVE } from "../../based/Constants";
import { ConfirmDialog } from "../../based/Dialog";
import CheckBox from "../../based/inputs/CheckBox";
import Loading from "../../based/Loading";
import { Notify } from "../../based/Notify";
import PlatformServices from "../../based/services/PlatformServices";

export default function TiktokConfig(props) {
    const history = useHistory();
    const [isBusy, setBusy] = useState(true);
    const [message, setMessage] = useState("Đang tải dữ liệu...");
    const [stores, setStores] = useState([]);
    const [storeSelected, setStorSelected] = useState(null);

    useEffect(() => {
        setBusy(false);
        connnect();
    }, []);
    async function connnect() {
        let fullParamUrl = window.location.search;
        if (fullParamUrl && fullParamUrl.indexOf("code=") > -1) {
            setBusy(true);
            setMessage("Đang tải dữ liệu..");
            const [err, data] = await PlatformServices.ConnectToPlatform(fullParamUrl + `&platform=${PLATFORM.Tiktok}`);
            if (!err) {
                setBusy(false);
                setMessage("");
                props.history.push("/connect-platform-config/tiktok");
            } else {
                if (err.data) Notify(NOTIFY.ERROR, "Lỗi", err.data);
                else Notify(NOTIFY.ERROR, "Lỗi", CONSTANTS.MSG_ERROR);
                setBusy(false);
                setMessage("");
                props.history.push("/connect-platform-config/tiktok");
            }
            _getStores();
        } else {
            _getStores();
        }
    }
    async function _getStores() {
        setBusy(true);
        setMessage("Đang tải dữ liệu..");
        const [err, data] = await PlatformServices.PlatformStoresUser([PLATFORM.Tiktok], STATUS_ACTIVE.All);
        if (!err) {
            setStores(data);
            setBusy(false);
            setMessage("");
        } else {
            setBusy(false);
            setMessage("");
        }
    }

    async function _syncSeller(platform) {
        const [err, data] = await PlatformServices.SyncSeller(platform);
        if (!err) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Đồng bộ danh mục thành công");
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Đồng bộ danh mục thất bại");
        }
    }

    async function _handleRemoveStore(id) {
        ConfirmDialog("Xác nhận", "Bạn chắc chắn muốn xóa kết nối đến gian hàng đã chọn? ", () => {
            return new Promise(async (resolve, reject) => {
                setBusy(true);
                setMessage("Đang xóa dữ liệu..");
                const [err, data] = await PlatformServices.DeleteConnectStore(id);
                if (!err) {
                    if (data) {
                        resolve({ title: "Thành công", msg: "Xóa kết nối gian hàng thành công" });
                        let storesUpdate = [...stores];
                        let idx = -1;
                        storesUpdate.map((item, i) => {
                            if (item.id == id) idx = i;
                        });
                        if (idx > -1) storesUpdate.splice(idx, 1);
                        setStores(storesUpdate);
                    } else {
                        reject(err);
                    }
                    setBusy(false);
                    setMessage("");
                } else {
                    Notify(NOTIFY.ERROR, "Lỗi", CONSTANTS.MSG_ERROR);
                    setBusy(false);
                    setMessage("");
                }
            });
        });
    }
    async function _handleConnect() {
        setBusy(true);
        setMessage("Đang kết nối tới gian hàng..");
        const [err, resdata] = await PlatformServices.ConnectToPlatform(`?platform=${PLATFORM.Tiktok}`);
        if (!err) {
            window.location.href = resdata;
            setBusy(false);
            setMessage("");
        } else {
            setBusy(false);
            setMessage("");
        }
    }
    async function _handleRefreshToken(store) {
        ConfirmDialog("Xác nhận", "Bạn chắc chắn muốn kết nối lại gian hàng đã chọn? ", () => {
            return new Promise(async (resolve, reject) => {
                setBusy(true);
                setMessage("Đang kết nối gian hàng..");
                const [err, data] = await PlatformServices.RefreshAccessToken({ id: store.id, shopId: store.shopId, platform: PLATFORM.Tiktok });
                if (!err) {
                    resolve({ title: "Thành công", msg: "Kết nối gian hàng thành công" });
                    _getStores();
                    setBusy(false);
                    setMessage("");
                } else {
                    reject({ title: "Có lỗi", msg: err.data ? err.data : CONSTANTS.MSG_ERROR });
                    setBusy(false);
                    setMessage("");
                }
            });
        });
    }

    async function _handleActiveStore(platform, shop, isActive) {
        const [err, data] = await PlatformServices.UpdateSetIsActiveShop(platform, shop, isActive);
        if (!err) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Cập nhật trạng thái gian hàng thành công");
            _getStores();
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Cập nhật trạng thái gian hàng thất bại");
        }
    }

    function _renderTable() {
        return stores && stores.length > 0 ? (
            <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <table className="tablesaw table mb-0 tablesaw-stack">
                        <thead>
                            <tr>
                                <th>Mã gian hàng (Shop Id)</th>
                                <th>Gian hàng (Shop Name)</th>
                                <th>Mã Seller (Shop Cipher)</th>
                                <th>Trạng thái</th>
                                <th>Ngày kết nối</th>
                                <th>Ngày hết hạn</th>
                                <th>Hoạt động</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {stores.map((store, k) => {
                                //get last 6 char of sellerId
                                if (store.sellerId && store.sellerId.length > 6) {
                                    store.sellerId = store.sellerId.substring(store.sellerId.length - 6);
                                }

                                return (
                                    <tr key={k} className={storeSelected && storeSelected.shopId == store.shopId ? "tr_selected" : ""}>
                                        <td className="vertical-align-middle">
                                            <strong className="store-name" onClick={() => setStorSelected(store)}>
                                                {store.shopId}
                                            </strong>
                                        </td>
                                        <td className="vertical-align-middle">
                                            <strong className="store-name" onClick={() => setStorSelected(store)}>
                                                {store.shopName}
                                            </strong>
                                        </td>
                                        <td className="vertical-align-middle">
                                            <span>{store.sellerId}</span>
                                        </td>
                                        <td className="vertical-align-middle">{!store.isExpired ? <span className="label label-table label-success"> Kích hoạt </span> : <span className="label label-table label-inverse">Hết hạn</span>}</td>
                                        <td className="vertical-align-middle">
                                            <span>{store.connectDate}</span>
                                        </td>
                                        <td className="vertical-align-middle">{store.connectDateExpires ? <span>{store.connectDateExpires}</span> : null}</td>
                                        <td className="vertical-align-middle">
                                            <CheckBox
                                                name={`isActive_${store.id}`}
                                                checked={store.isActive}
                                                onCheckedChange={(name, value) => {
                                                    _handleActiveStore(PLATFORM.Tiktok, store.shopId, value);
                                                }}
                                                label="Kích hoạt"
                                            />
                                        </td>
                                        <td className="vertical-align-middle">
                                            {store.isActive ? null : (
                                                <button className="btn btn-custom btn-sm m-r-5" onClick={() => _handleRefreshToken(store)}>
                                                    <i className="fa fa-refresh"></i>
                                                </button>
                                            )}
                                            <button
                                                className="btn btn-custom btn-sm m-1"
                                                onClick={(e) => {
                                                    history.push(`/platform-shop-management/${store.shopId}/${PLATFORM.Tiktok}`);
                                                }}
                                            >
                                                Chi tiết
                                            </button>
                                            <button className="btn btn-danger btn-sm" onClick={() => _handleRemoveStore(store.id)}>
                                                <i className="fa fa-trash-o"></i>
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        ) : null;
    }
    return (
        <React.Fragment>
            <Loading show={isBusy} msg={message} />
            <div className="row ml-2">
                <div className="col-sm-12 form-row card-box p-3">
                    <div className="col-12 col-lg-12">
                        <div className="lazada-channel--text">
                            <button className="btn btn-custom m-2 form-group" onClick={() => _handleConnect()}>
                                <span>
                                    <i className="fa fa-share-alt"></i> Kết nối kênh bán hàng
                                </span>
                            </button>
                            <button
                                className="btn btn-info m-2 form-group"
                                onClick={(e) => {
                                    _syncSeller(PLATFORM.Tiktok);
                                }}
                            >
                                <span>Đồng bộ Shop Cipher</span>
                            </button>
                        </div>
                        <hr />
                        {_renderTable()}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
